import { Grid, Typography } from '@mui/material';

import ScrollContainer from 'UI/containers/ScrollContainer/ScrollContainer';
import { useT } from 'UI/lib';

const CommentSuggestionBox = ({ comment, managerName }) => {
  const t = useT();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6" component="p" sx={{ fontSize: 16, fontWeight: 600 }}>
          {t('restrict:skills.dialog.skill_suggestion_comment', { name: managerName })}:
        </Typography>
      </Grid>
      <ScrollContainer
        item
        xs={12}
        sx={{ maxHeight: 'calc(4em * 1.71)', overflow: 'auto', lineHeight: '1.71' }}
      >
        <Typography sx={theme => ({ color: theme.palette.custom.primary })}>{comment}</Typography>
      </ScrollContainer>
    </Grid>
  );
};

export default CommentSuggestionBox;
